import React from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo.png";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  return (
    <footer className={"" + props.hclass}>
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={logo} alt="Logo WM Clinic" />
                </div>
                <p>
                  Ofrecemos soluciones quirúrgicas y médicas avanzadas, con
                  tecnología de punta y un equipo médico capacitado y
                  comprometido.
                </p>
                <div className="social-widget">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/wmclinic.oficial"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Síguenos en Facebook"
                      >
                        <i className="flaticon-facebook-app-symbol"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/wmclinic.oficial/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Síguenos en Instagram"
                      >
                        <i className="flaticon-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/channel/UCFnm1ANHHbvJj3MTHpYb5qg"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Síguenos en YouTube"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ display: 'inline-block', verticalAlign: 'middle' }}
                        >
                          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Links rápidos</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/home">
                      Inicio
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      Clinica
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/services">
                      Especialidades
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/gallery">
                      Galería de fotos
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contacto
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget contact-widget">
                <div className="widget-title">
                  <h3>Contáctanos</h3>
                </div>
                <ul>
                  <li>
                    <i className="flaticon-email"></i>
                    <span>wmclinicplus@gmail.com</span>
                  </li>
                  <li>
                    <i className="flaticon-location-1"></i>
                    <span>
                      Urbanización Av. Panteón, <br />
                      Caracas, Venezuela
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row g-0">
            <div className="col col-lg-6 col-12">
              <p className="copyright">
                Powered by{" "}
                <Link onClick={ClickHandler} to="/">
                  santocodigo
                </Link>
                . Todos los derechos reservados.
              </p>
            </div>
            <div className="col col-lg-6 col-12">
              <ul>
                <li>
                  <Link onClick={ClickHandler} to="#">
                    Política de privacidad
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="#">
                    Terminos y condiciones
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/about">
                    Sobre nosotros
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/faq">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
